import { AllTableColumnsConfig } from '@/__configs/config_types';
import { getLineageMetaTitle } from '@/_utils/utils';
import { TitleEntity } from '@/redux/slices/slice_types';
import { Typography } from '@mui/material';
import { DateTimeDisplay, Thumbnail, TitleTypeLabel } from '../../../../exports/columnCommonComponents';

const columns: AllTableColumnsConfig<TitleEntity> = {
  thumbnail_link: {
    label: '',
    disableSort: true,
    width: 50,
    render: (cell: TitleEntity['thumbnail_link'], row: TitleEntity) => <Thumbnail src={cell} type={row.entity_type} />
  },
  hid: {
    label: 'Title ID',
    sortField: 'id',
    render: (cell: TitleEntity['external_id']) => (cell ? <strong style={{ color: 'var(--primary-main)' }}>{cell}</strong> : '-')
  },
  name: {
    label: 'Title',
    minWidth: 280,
    render: (cell: TitleEntity['name'], row: TitleEntity) => (
      <>
        <div>{cell}</div>
        <Typography variant="caption" sx={{ lineHeight: 1.9, fontSize: '.9rem' }}>
          {getLineageMetaTitle(row)}
        </Typography>
      </>
    )
  },
  entity_type: {
    label: 'Type',
    render: (cell: TitleEntity['entity_type']) => <TitleTypeLabel width="fit-content" type={cell} />
  },
  external_id: {
    label: 'External ID'
  },
  class: {
    label: 'Class',
    render: (_: TitleEntity['class'], row: TitleEntity) => (
      <span>{row.entity_type === 'series' ? row?.metadata_values?.series_class || '-' : row?.metadata_values?.episode_class || '-'}</span>
    )
  },
  created_at: {
    label: 'Created',
    position: 'left',
    sortField: 'created_at',
    render: (cell: TitleEntity['created_at']) => <DateTimeDisplay>{cell}</DateTimeDisplay>
  }
};

export default columns;
